import { render, staticRenderFns } from "./ContributeTime.vue?vue&type=template&id=0529617e&scoped=true"
import script from "./ContributeTime.vue?vue&type=script&lang=ts"
export * from "./ContributeTime.vue?vue&type=script&lang=ts"
import style0 from "./ContributeTime.vue?vue&type=style&index=0&id=0529617e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0529617e",
  null
  
)

export default component.exports